/* eslint-disable @typescript-eslint/no-empty-function */
import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';

import {
  CdkDragDrop,
  DragDropModule,
  moveItemInArray,
} from '@angular/cdk/drag-drop';

import { Spinner } from '../spinner/spinner.component';
import { FileItem, FileUploaderAdapter } from './file-uploader.adapter';

@Component({
  selector: 'lepi-file-uploader',
  standalone: true,
  imports: [CommonModule, DragDropModule, Spinner],
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
  providers: [],
})
export class FileUploader extends FileUploaderAdapter {
  // 드래그/드롭 시 드래그가 끝났는지 여부
  isDragOvered = signal(false);

  onDragOver(e: DragEvent) {
    this.isDragOvered.set(true);
    e.preventDefault();
  }

  onDragLeave(e: DragEvent) {
    this.isDragOvered.set(false);
    e.preventDefault();
  }

  onDragDrop(e: DragEvent) {
    this.isDragOvered.set(false);
    this.onFileDrop(e);
  }

  openImage(url: string) {
    window.open(url);
  }

  onDrop(ev: CdkDragDrop<FileItem[]>) {
    if (ev.container === ev.previousContainer) {
      this.items.update(items => {
        const temp = items;
        moveItemInArray(temp, ev.previousIndex, ev.currentIndex);
        return temp;
      });
    }
  }
}
